import { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import Navigation from './Navigation';
import NavBar from './NavBar';
import usePageTitle from '../../hooks/usePageTitle';
import { useModuloControle } from '../../contexts/ModuloControleContext';
import { ConfigContext } from '../../contexts/ConfigContext';

const MobileLayout = ({ children }) => {
  const { contaBloqueada, notificacao } = useModuloControle();
  const location = useLocation();
  const configContext = useContext(ConfigContext);
  const { headerFixedLayout } = configContext.state;
  
  // Atualiza o título da página automaticamente
  usePageTitle();

  const navigation = (
    <div className={['nav-outside', headerFixedLayout && 'mob-fixed'].filter(Boolean).join(' ')}>
      <Navigation />
      <NavBar />
    </div>
  );

  return (
    <>
      {navigation}
      <div className='pcoded-main-container mobile-layout'>
        <div className='pcoded-wrapper'>
          <div className='pcoded-content'>
            <div className='pcoded-inner-content mobile-content'>
              {!contaBloqueada && location.pathname.indexOf('inicio') === -1 && notificacao}
              {children}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MobileLayout;
